import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    FormGroup, Label, Input, Col, Form, Button, FormText, InputGroup, InputGroupAddon,
    InputGroupText, Collapse, UncontrolledPopover, PopoverBody
} from 'reactstrap';
import _ from 'lodash';
import {Utils} from "../../../utils/utils";
import './OrgFinanceManagement.css';
import {CURRENCIES} from '../../../constants/constants';
import DatePicker from 'react-datepicker';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import moment from 'moment';
import Select from '../../commonComponents/customSelect/CustomSelect.container';
import IconContainer from "../../commonComponents/iconContainer/IconContainer";

export const EDIT_ORG_MODE = "EDIT_ORG_MODE";
export const VALIDATE_ORG_MODE = "VALIDATE_ORG_MODE";

class OrgFinanceManagement extends Component {
    constructor(props) {
        super(props);

        this.state = {
            balanceCurrency: 'USD',
            paidTillDate: null,
            paidTillInputValue: '',
            annualFee: '',
            consentRequestFee: '',
            deviationDate: null,
            deviationDateForever: false,
            deviationInputValue: '',
            financialData: ''
        };
    }

    componentWillMount() {
        if (!_.isNil(this.props.data)) {
            if (this.props.currentPresetId === this.props.data.presetId) {
                let annualFee = this.props.data.annualFee ? this.props.data.annualFee : this.props.currentPresetData.annualFee;
                let consentRequestFee = this.props.data.consentRequestFee ? this.props.data.consentRequestFee : this.props.currentPresetData.consentRequestFee;

                this.setState({
                    balanceCurrency: this.props.data.balanceCurrency,
                    paidTillDate: !_.isNil(this.props.data.paidTillDate) ? moment(this.props.data.paidTillDate) : null,
                    paidTillInputValue: !_.isNil(this.props.data.paidTillDate) ? moment(this.props.data.paidTillDate).format('L') : '',
                    financialData: this.props.data.financialData,
                    annualFee: annualFee.amount.toFixed(2),
                    consentRequestFee: consentRequestFee.amount.toFixed(2),
                    deviationDate: !_.isNil(this.props.data.deviationDate) ? moment(this.props.data.deviationDate) : null,
                    deviationInputValue: !_.isNil(this.props.data.deviationDate) ? moment(this.props.data.deviationDate).format('L') : '',
                    deviationDateForever: this.props.data.deviationDateForever
                })
            } else {
                this.props.onChangePreset(this.props.data.presetId);
                this.setState({
                    balanceCurrency: this.props.data.balanceCurrency,
                    paidTillDate: !_.isNil(this.props.data.paidTillDate) ? moment(this.props.data.paidTillDate) : null,
                    paidTillInputValue: !_.isNil(this.props.data.paidTillDate) ? moment(this.props.data.paidTillDate).format('L') : '',
                    deviationDate: !_.isNil(this.props.data.deviationDate) ? moment(this.props.data.deviationDate) : null,
                    deviationInputValue: !_.isNil(this.props.data.deviationDate) ? moment(this.props.data.deviationDate).format('L') : '',
                    deviationDateForever: this.props.data.deviationDateForever,
                    financialData: this.props.data.financialData
                })
            }
        }
    }

    componentWillUpdate(nextProps) {
        if ((!_.isNil(nextProps.data) && !_.isNil(nextProps.currentPresetData)) && (_.isNil(this.props.data) || _.isNil(this.props.currentPresetData))) {
            let annualFee = nextProps.data.annualFee ? nextProps.data.annualFee : nextProps.currentPresetData.annualFee;
            let consentRequestFee = nextProps.data.consentRequestFee ? nextProps.data.consentRequestFee : nextProps.currentPresetData.consentRequestFee;
            this.setState({
                annualFee: annualFee.amount.toFixed(2),
                consentRequestFee: consentRequestFee.amount.toFixed(2)
            })
        } else if (!_.isNil(this.props.currentPresetData) && !_.isNil(nextProps.currentPresetData) && !_.isEqual(this.props.currentPresetData, nextProps.currentPresetData)) {
            let annualFee = this.state.annualFee === "" || Number(this.state.annualFee) === this.props.currentPresetData.annualFee.amount ? nextProps.currentPresetData.annualFee.amount : Number(this.state.annualFee);
            let consentRequestFee = this.state.consentRequestFee === "" || Number(this.state.consentRequestFee) === this.props.currentPresetData.consentRequestFee.amount ? nextProps.currentPresetData.consentRequestFee.amount : Number(this.state.consentRequestFee);
            this.setState({
                annualFee: annualFee.toFixed(2),
                consentRequestFee: consentRequestFee.toFixed(2)
            })
        }
    }

    componentDidUpdate() {
        if (this.props.onChangeSubmitStatus) {
            this.props.onChangeSubmitStatus(this.saveButtonDisabled());
        }
    }

    componentWillUnmount() {
        this.props.onChangePreset();
    }

    render() {
        if (_.isNil(this.props.data) || _.isNil(this.props.currentPresetData)) {
            return null;
        }

        return (
            <Form className="org-finance-edit" onSubmit={this.onFinanceEdit}>
                {this.renderFinancialDataFromGroup()}
                {this.renderPaidTillDateFormGroup()}
                {this.renderBalanceFormGroup()}
                {this.renderPresetFormGroup()}
                {this.renderPriceFormGroups()}
                <div className="buttons-group">
                    <Button type="submit"
                            disabled={this.saveButtonDisabled()}
                            className="olive-green-btn">{_.get(this.props.translation, sharedLabelsPath.save_changes_button)}</Button>
                </div>
            </Form>
        );
    }

    saveButtonDisabled = () => {
        if(_.isNil(this.props.data)) {
            return true;
        }
        let annualFee = this.props.data.annualFee ? this.props.data.annualFee : this.props.currentPresetData.annualFee;
        let consentRequestFee = this.props.data.consentRequestFee ? this.props.data.consentRequestFee : this.props.currentPresetData.consentRequestFee;

        let sameDeviationDate;
        if (this.state.deviationDateForever) {
            sameDeviationDate = this.state.deviationDateForever === this.props.data.deviationDateForever;
        } else {
            sameDeviationDate = (this.props.data.deviationDate ? moment(this.props.data.deviationDate).format('L') : '') === this.state.deviationInputValue;
        }
        return (sameDeviationDate &&
                this.state.balanceCurrency === this.props.data.balanceCurrency &&
                (this.props.data.paidTillDate ? moment(this.props.data.paidTillDate).format('L') : '') === this.state.paidTillInputValue &&
                this.props.data.presetId === this.props.currentPresetId &&
                Number(this.getCurrentFee('annualFee')) === annualFee.amount &&
                Number(this.getCurrentFee('consentRequestFee')) === consentRequestFee.amount &&
                this.props.data.financialData === this.state.financialData) ||
            !this.isDateValid(this.state.paidTillInputValue, true)
            || !this.isDateValid(this.state.deviationInputValue, true)
    };

    getCurrentFee = (fieldKey) => _.isEmpty(this.state[fieldKey]) ? this.props.currentPresetData[fieldKey].amount : this.state[fieldKey];

    renderFinancialDataFromGroup = () => {
        let hintText = [
            <div key='part_1'>{_.get(this.props.translation, 'register_org.financial_data_hint_part_1')}</div>,
            <div key='part_2'>{_.get(this.props.translation, 'register_org.financial_data_hint_part_2')}</div>,
            <div key='part_3'>{_.get(this.props.translation, 'register_org.financial_data_hint_part_3')}</div>
        ];

        return (
            <FormGroup row>
                <div className="validate-org-hint-container">
                    <span id="edit-finance-financial-data" className='validate-org-icon-container'>
                        <IconContainer icon='question_mark' title={_.get(this.props.translation, sharedLabelsPath.about_label)} />
                    </span>
                    <UncontrolledPopover placement="bottom" trigger="legacy" target="edit-finance-financial-data">
                        <PopoverBody>
                            {hintText}
                        </PopoverBody>
                    </UncontrolledPopover>
                </div>
                <Label for="financial-data-field" sm={4}>{_.get(this.props.translation, 'orgs.financial_data_label') + "*"}</Label>
                <Col sm={8}>
                    <Input type="textarea" id="financial-data-field"
                           value={this.state.financialData}
                           onChange={this.handleChange('financialData')}
                           placeholder={_.get(this.props.translation, 'orgs.financial_data_placeholder')}
                           required
                    />
                </Col>
            </FormGroup>
        )
    }

    renderPaidTillDateFormGroup = () => {
        return (
            <FormGroup row>
                <div className="validate-org-hint-container">
                    <span id="paid-till-icon-container" className='validate-org-icon-container'>
                        <IconContainer className="paid-till-info-icon" icon='info' title={_.get(this.props.translation, sharedLabelsPath.about_label)} />
                    </span>
                    <UncontrolledPopover placement="bottom" trigger="legacy" target="paid-till-icon-container">
                        <PopoverBody className="validate-org-hint-popover-body">
                            {Utils.getTagsFromStringWithStyles(_.get(this.props.translation, 'finance.paid_till_alert'))}
                        </PopoverBody>
                    </UncontrolledPopover>
                </div>
                <Label sm={4}>{_.get(this.props.translation, 'finance.paid_till_date_label')}</Label>
                <Col sm={!_.isNil(this.props.data.paidTillDate) ? 6 : 8} className='paid-till-input-container'>
                    <DatePicker
                        customInput={<Input invalid={!this.isDateValid(this.state.paidTillInputValue, true)}/>}
                        onBlur={this.handleDateBlur('paidTillDate', 'paidTillInputValue')}
                        onChange={this.handleChangeDate('paidTillDate', 'paidTillInputValue')}
                        onChangeRaw={this.handleChange('paidTillInputValue')}
                        value={this.state.paidTillInputValue}
                        // NOTE: date in the past is invalid for DatePicker with minDate = NOW
                        selected={this.isDateValid(this.state.paidTillInputValue, true) ? this.state.paidTillDate : null}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText={_.get(this.props.translation, sharedLabelsPath.datepicker_placeholder)}
                        minDate={this.props.data.paidTillDate ? moment.max(moment(), moment(this.props.data.paidTillDate)) : moment()}
                    />
                </Col>
                {
                    !_.isNil(this.props.data.paidTillDate) && this.props.mode !== VALIDATE_ORG_MODE ?
                        <Col sm={2}>
                            <Button
                                className="olive-green-btn"
                                onClick={this.handleAddYearIconClick}
                            >
                                {_.get(this.props.translation, 'finance.add_year_label')}
                            </Button>
                        </Col>
                        : null
                }
            </FormGroup>
        );
    };

    isDateValid = (value, strict) => {
        return value === '' ||
            (moment(value, 'L', strict).isValid() &&
                moment(value, 'L').isSameOrAfter(moment().startOf('day')));
    };

    renderPresetFormGroup = () => {
        let defaultAnnualFee = Number(this.getCurrentFee("annualFee")) === this.props.currentPresetData.annualFee.amount;
        let defaultConsentRequestFee = Number(this.getCurrentFee("consentRequestFee")) === this.props.currentPresetData.consentRequestFee.amount;

        return (
            <FormGroup row>
                <Label sm={4}>{_.get(this.props.translation, 'finance.preset_price_label')}</Label>
                <Col sm={8}>
                    <Select
                        selectedOption={_.find(Utils.getPresetsOptions(this.props.presetsData), option =>
                            option.value === this.props.currentPresetId)}
                        options={Utils.getPresetsOptions(this.props.presetsData)}
                        onSelect={this.handleChangePreset}
                        isSearchable={false}/>
                    <Collapse isOpen={!defaultAnnualFee || !defaultConsentRequestFee}>
                        <FormText color="muted" className='org-finance-edit-form-text'>
                            {_.get(this.props.translation, 'finance.default_preset_label')
                                .replace('{annual_fee_amount}', this.props.currentPresetData.annualFee.amount + CURRENCIES[this.props.currentPresetData.annualFee.currency])
                                .replace('{consent_request_fee_amount}', this.props.currentPresetData.consentRequestFee.amount + CURRENCIES[this.props.currentPresetData.annualFee.currency])}
                        </FormText>
                    </Collapse>
                </Col>

            </FormGroup>
        );
    };

    renderBalanceFormGroup = () => {
        return (
            <FormGroup row>
                <Label sm={4}>{_.get(this.props.translation, 'finance.balance_currency_label')}</Label>
                {
                    this.props.mode !== VALIDATE_ORG_MODE ?
                    <Col sm={6}>
                        <Input
                            readOnly
                            value={(!_.isNil(this.props.convertedBalance) && this.props.data.balanceCurrency !== this.state.balanceCurrency) ? this.props.convertedBalance : this.props.data.balance}
                        />
                    </Col>
                    : null
                }
                <Col sm={this.props.mode !== VALIDATE_ORG_MODE ? 2 : 8} className="currency-select-container">
                    <Select
                        selectedOption={_.find(Utils.getCurrenciesOptions(this.props.currenciesData), option =>
                            option.value === this.state.balanceCurrency)}
                        options={Utils.getCurrenciesOptions(this.props.currenciesData)}
                        onSelect={this.handleChangeBalanceCurrency}
                        isSearchable={false}/>
                </Col>
            </FormGroup>
        );
    };

    renderPriceFormGroups = () => {
        let defaultAnnualFee = Number(this.getCurrentFee("annualFee")) === this.props.currentPresetData.annualFee.amount;
        let defaultConsentRequestFee = Number(this.getCurrentFee("consentRequestFee")) === this.props.currentPresetData.consentRequestFee.amount;

        return [
            <FormGroup row key="annual-fee-form-group">
                <Label sm={4}>{_.get(this.props.translation, 'finance.annual_fee_label')}</Label>
                <Col sm={7} className='org-finance-edit-input-container'>
                    <InputGroup>
                        <Input
                            className={'org-finance-edit-input ' + (defaultAnnualFee ? 'default' : '')}
                            type="number"
                            min={0}
                            step="any"
                            value={this.state.annualFee}
                            onChange={this.handleChange('annualFee')}
                            onBlur={this.handleBlur('annualFee')}
                            invalid={Number(this.state.annualFee) < 0}
                            required
                        />
                        <InputGroupAddon addonType="append">
                            <InputGroupText>{CURRENCIES[this.props.currentPresetData.annualFee.currency]}</InputGroupText>
                        </InputGroupAddon>
                    </InputGroup>
                    <Collapse isOpen={defaultAnnualFee}>
                        <FormText color="muted" className='org-finance-edit-form-text'>
                            {_.get(this.props.translation, 'finance.default_annual_fee_label')}
                        </FormText>
                    </Collapse>
                </Col>
                <Col sm={1} className='org-finance-edit-icon-container'>
                    <IconContainer icon='restore'
                                   className={'org-finance-edit-icon' + (defaultAnnualFee ? ' default' : '')}
                                   title={_.get(this.props.translation, 'finance.set_default_label')}
                                   onClick={this.resetToDefault('annualFee')}/>
                </Col>
            </FormGroup>,
            <FormGroup row key="request-cost-form-group">
                <Label className='label' sm={4}>{_.get(this.props.translation, 'finance.request_cost_label')}</Label>
                <Col sm={7} className='org-finance-edit-input-container'>
                    <InputGroup>
                        <Input
                            className={'org-finance-edit-input ' + (defaultConsentRequestFee ? 'default' : '')}
                            type="number"
                            min={0}
                            step="any"
                            value={this.state.consentRequestFee}
                            onChange={this.handleChange('consentRequestFee')}
                            onBlur={this.handleBlur('consentRequestFee')}
                            invalid={Number(this.state.consentRequestFee) < 0}
                            required
                        />
                        <InputGroupAddon addonType="append">
                            <InputGroupText>{CURRENCIES[this.props.currentPresetData.consentRequestFee.currency]}</InputGroupText>
                        </InputGroupAddon>
                    </InputGroup>
                    <Collapse isOpen={defaultConsentRequestFee}>
                        <FormText color="muted"
                                  className='org-finance-edit-form-text'>
                            {_.get(this.props.translation, 'finance.default_consent_request_fee_label')}
                        </FormText>
                    </Collapse>
                </Col>
                <Col sm={1} className='org-finance-edit-icon-container'>
                    <IconContainer icon='restore'
                                   className={'org-finance-edit-icon' + (defaultConsentRequestFee ? ' default' : '')}
                                   title={_.get(this.props.translation, 'finance.set_default_label')}
                                   onClick={this.resetToDefault('consentRequestFee')}/>
                </Col>
            </FormGroup>,
                <FormGroup row className='deviation-form-group' key='deviation-form-group'>
                    <Label
                        sm={4}>{_.get(this.props.translation, 'finance.deviation_period_label')}</Label>
                    <Col sm={8}>
                        <DatePicker
                            customInput={<Input
                                invalid={!this.isDateValid(this.state.deviationInputValue, true)}/>}
                            onBlur={this.handleDateBlur('deviationDate', 'deviationInputValue')}
                            onChange={this.handleChangeDate('deviationDate', 'deviationInputValue')}
                            onChangeRaw={this.handleChange('deviationInputValue')}
                            value={this.state.deviationInputValue}
                            selected={this.state.deviationDate}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            placeholderText={_.get(this.props.translation, sharedLabelsPath.datepicker_placeholder)}
                            minDate={moment()}
                            disabled={(defaultAnnualFee && defaultConsentRequestFee) || this.state.deviationDateForever}
                            required={(!defaultAnnualFee || !defaultConsentRequestFee) && !this.state.deviationDateForever}
                        />
                        <div className='checkbox-container'>
                            <Label check>
                                <Input
                                    type="checkbox"
                                    checked={this.state.deviationDateForever}
                                    onChange={this.toggleCheckBox('deviationDateForever')}
                                    disabled={defaultAnnualFee && defaultConsentRequestFee}
                                />
                                {_.get(this.props.translation, 'finance.forever_label')}
                            </Label>
                        </div>
                    </Col>
                </FormGroup>
        ];
    };

    handleAddYearIconClick = () => {
        let startDate = moment(this.state.paidTillDate);

        if (!moment(this.state.paidTillDate, 'L').isSameOrAfter(moment().startOf('day'))) {
            startDate = moment();
        }

        let newDate = startDate.add(1, 'year');

        this.setState({
            paidTillDate: newDate,
            paidTillInputValue: newDate.format('L')
        });
    };

    toggleCheckBox = (fieldKey) => () => {
        this.setState({[fieldKey]: !this.state[fieldKey]})
    };

    resetToDefault = (fieldKey) => () => {
        this.setState({[fieldKey]: Number(this.props.currentPresetData[fieldKey].amount).toFixed(2)});
    };

    handleChange = (fieldKey) => (e) => {
        this.setState({[fieldKey]: e.target.value});
    };

    handleBlur = (fieldKey) => () => {
        if (_.isEmpty(this.state[fieldKey])) {
            this.resetToDefault(fieldKey)()
        } else {
            this.setState({[fieldKey]: Number(this.state[fieldKey]).toFixed(2)})
        }
    };

    handleDateBlur = (dateFieldKey, inputFieldKey) => () => {
        if ((_.isNil(this.state[dateFieldKey]) ? '' : this.state[dateFieldKey].format('L')) !== this.state[inputFieldKey]) {
            if (this.isDateValid(inputFieldKey, false)) {
                this.setState({
                    [inputFieldKey]: moment(this.state[inputFieldKey], 'L').format('L'),
                    [dateFieldKey]: moment(this.state[inputFieldKey], 'L')
                });
            } else {
                this.setState({
                    [inputFieldKey]: _.isNil(this.state[dateFieldKey]) ? '' : this.state[dateFieldKey].format('L')
                });
            }
        }
    };

    handleChangeDate = (dateFieldKey, inputFieldKey) => (date) => {
        this.setState({
            [dateFieldKey]: date,
            [inputFieldKey]: _.isNil(date) ? '' : date.format('L')
        });
    };

    handleChangePreset = (selectedOption) => {
        this.props.onChangePreset(selectedOption.value);
    };

    handleChangeBalanceCurrency = (selectedOption) => {
        this.setState({balanceCurrency: selectedOption.value});
        if (this.props.data.balanceCurrency !== selectedOption.value) {
            let data = {
                amount: this.props.data.balance,
                currencyFrom: this.props.data.balanceCurrency,
                currencyTo: selectedOption.value
            };
            this.props.onConvertMoney(data);
        }
    };

    onFinanceEdit = (e) => {
        e.preventDefault();

        let data = {
            pricing: {
                pricingPreset: {
                    id: this.props.currentPresetId
                }
            },
            balance: {
                currency: this.state.balanceCurrency
            },
            financialData: this.state.financialData
        };

        if (this.props.currentPresetData.annualFee.amount !== Number(this.state.annualFee)) {
            data.pricing.annualFee = {
                amount: Number(this.state.annualFee),
                currency: this.props.currentPresetData.annualFee.currency
            };
        }

        if (this.props.currentPresetData.consentRequestFee.amount !== Number(this.state.consentRequestFee)) {
            data.pricing.consentRequestFee = {
                amount: Number(this.state.consentRequestFee),
                currency: this.props.currentPresetData.consentRequestFee.currency
            };
        }

        if (data.pricing.annualFee || data.pricing.consentRequestFee) {
            data.pricing["validTill"] = this.state.deviationDateForever ? null : this.state.deviationDate;
        }

        if (!_.isNil(this.state.paidTillDate)) {
            data["paidTill"] = this.state.paidTillDate.format('YYYY-MM-DD');
        }

        if (this.props.onUpdateOrgFinanceDataSubmit) {
            this.props.onUpdateOrgFinanceDataSubmit();
        }

        this.props.onChangePrice(this.props.id, data);
    };
}

OrgFinanceManagement.defaultProps = {
    mode: EDIT_ORG_MODE
};

OrgFinanceManagement.propTypes = {
    mode: PropTypes.string,
    data: PropTypes.object,
    convertedBalance: PropTypes.number,
    currentPresetId: PropTypes.string,
    currentPresetData: PropTypes.object,
    presetsData: PropTypes.array,
    currenciesData: PropTypes.array,
    translation: PropTypes.object.isRequired,
    onChangePreset: PropTypes.func.isRequired,
    onChangePrice: PropTypes.func.isRequired,
    onConvertMoney: PropTypes.func.isRequired,
    onUpdateOrgFinanceDataSubmit: PropTypes.func,
    onChangeSubmitStatus: PropTypes.func
};

export default OrgFinanceManagement;



// WEBPACK FOOTER //
// ./src/components/organizationManagement/orgFinanceManagement/OrgFinanceManagement.js